import { contains } from "ramda"

import { LocaleType } from "./types"

type LocaleFuncType = (language: string, territory: string) => LocaleType

export const createLocale: LocaleFuncType = (language, territory) => {
  const fullLocale = `${language}-${territory}`
  return { language, territory, fullLocale }
}

export const getLocale = (
  userLocales: string[],
  validLocales: LocaleType[] = [],
): LocaleType | null => {
  // eslint-disable-next-line no-restricted-syntax
  for (const userLocale of userLocales) {
    if (userLocale.includes("-")) {
      const splitUserLocale: string[] = userLocale.split("-")
      return createLocale(splitUserLocale[0], splitUserLocale[1])
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const validLocale of validLocales) {
      if (validLocale.language === userLocale) {
        return createLocale(userLocale, validLocale.territory)
      }
    }
  }
  return null
}

export const getSupportedLocale = (
  locale: LocaleType | null,
  supportedLocales: LocaleType[],
  defaultLocale: LocaleType,
): LocaleType => (locale && contains(locale, supportedLocales) ? locale : defaultLocale)
